'use strict'

/**
 * Хранилище всех имен view, доступных для роутинга
 */

export const VIEWS = {
    init: createView('init', 'Init'),
    home: createView('home', 'Home'),
    phone: createView('phone', 'Phone'),
    client: createView('client', 'Client'),
    servicing: createView('client', 'Servicing'),
    success: createView('success', 'Success'),
    preRegistrationFrameProfile: createView('preRegistrationFrameRegistrator', 'PreRegistrationFrameRegistrator'),
    successRegistration: createView('successRegistration', 'successRegistration')
}

function createView(type, name) {
    return {
        moduleType: type,
        name: name
    }
}
